import { PURCHASE_AGREEMENT_DOCUMENT_TYPE_NAME } from './LoanActionAppraisalServiceRow.constants';

const purchaseAgreementName = PURCHASE_AGREEMENT_DOCUMENT_TYPE_NAME.toLowerCase();

// The Purchase Agreement is always uploaded to a Reggora order on its own path, so it is not offered here.
export const excludePurchaseAgreement = documentTypesOptions =>
  documentTypesOptions.filter(({ name }) => name?.toLowerCase() !== purchaseAgreementName);
